import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {AuthenticationService} from './_service/authentication.service';
import {BusinessService} from './_service/business.service';
import {LoginResponseModel} from './models/LoginResponse.model';
import {firstValueFrom, map} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'backoffice2';
  pageLoaded = false;
  constructor(private translate: TranslateService, private authService: AuthenticationService, private businessService: BusinessService) {
  }

  async ngOnInit() {
    this.pageLoaded = false;
    this.translate.addLangs(['en', 'en-gb', 'en-us', 'es', 'es-es', 'fr']);
    this.translate.setDefaultLang('en-us');
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      this.translate.use(storedLanguage);
    } else {
      this.translate.use('en');
      localStorage.setItem('language', 'en');
    }
    this.pageLoaded = true;
  }

  isAuth(): boolean {
    return this.authService.isAuth();
  }
}
